import { Box, Grid, Skeleton } from "@mui/material";
import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { FCol } from "../../../../globalComponents/standard";
import CustomerDetailsContext from "./context";
import FormInfo from "./formInfo";
import StatsComponent from "./statsComponent";
import CustomerTransactions from "./transactions";
import { useCustomerDetailsManager } from "./useCustomerDetails";

const CustomerDetails = () => {
  const { loading } = useContext(CustomerDetailsContext);

  return (
    <Box
      sx={{
        margin: 0,
        height: "100vh", // full screen
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {loading ? (
        <React.Fragment>
          <FCol>
            <Skeleton height={60} />
            <Skeleton height={30} />
            <Skeleton height={30} />
            <Skeleton height={30} />
            <Skeleton height={70} />
            <Skeleton height={30} />
            <Skeleton height={300} />
          </FCol>
        </React.Fragment>
      ) : (
        <>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <FormInfo />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <StatsComponent />
            </Grid>
            <Grid size={{ xs: 12 }} sx={{ mb: 20 }}>
              <CustomerTransactions />
            </Grid>
          </Grid>
          {/* <Snackbar open={success} autoHideDuration={3000}>
            <Alert severity="success">Cliente cadastrado com sucesso!</Alert>
          </Snackbar> */}
        </>
      )}
    </Box>
  );
};

const Index = () => {
  const { id } = useParams();
  return (
    <CustomerDetailsContext.Provider value={useCustomerDetailsManager(id)}>
      <CustomerDetails />
    </CustomerDetailsContext.Provider>
  );
};

export default Index;
